<template lang="html">
  <div class="patrimonial-form">
		<div class="label">
			En fonction des réponses que vous avez renseigné, voici le profil qui vous correspond le mieux :
		</div>
		<div class="badge" v-if="sync">
			<div class="btn btn-white no-click" v-if="profile">
				<img :src="imgBtn" alt="">
				{{ profile }}
			</div>
			<div v-else>
				Aucune réponse renseigné, veuillez sauvegarder et réessayer à nouveau
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import star from '@/common/assets/img/investor/star.svg'
import disc from '@/common/assets/img/investor/disc.svg'
import shield from '@/common/assets/img/investor/shield.svg'
import lightning from '@/common/assets/img/investor/lightning-bolt.svg'
import EstateResource from '@/common/resources/Estate'
export default {
	name: 'Profil',
	props: ['user'],
	data () {
		return {
			sync: false,
			profile: null
		}
	},
	mounted () {
		this.$store.commit('LOADER_IN')
		this.$store.dispatch('savePatrimonial', this.user.id).then(() => {
			EstateResource.getInvestisorProfil(this.user.id).then((result) => {
				this.$store.commit('LOADER_OUT')
				this.profile = result.data.investor_profile
				this.sync = true
			}).catch((error) => {
				this.$store.commit('LOADER_OUT')
				console.warn(error.response)
			})
		})
	},
	methods: {
		validate () {
			return new Promise((resolve, reject) => { resolve(true) })
		}
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		}),
		imgBtn () {
			let img = null
			switch (this.profile) {
			case 'Aguerri':
				img = star
				break
			case 'Equilibré':
				img = disc
				break
			case 'Prudent':
				img = shield
				break
			case 'Dynamique':
				img = lightning
				break
			default:
				return null
			}

			return img
		}
	}
}
</script>

<style lang="scss" scoped>
.btn-white {
	margin-left: 1rem;
	margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/common/components/MyPatrimonialLandscape/Profil.vue